/**
 * A data table. `columns` is [{ key, header, align, mono }]; each row is an object keyed by
 * column key plus a unique `id`. Cells hold text or small components (a status, a badge).
 */
const Table = ({ columns, rows, caption }) => {
  return (
    <div className="comp-table">
      <table>
        {caption && <caption className="comp-table__caption">{caption}</caption>}
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} scope="col" data-align={column.align}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((column) => (
                <td key={column.key} data-align={column.align} data-mono={column.mono ? 'true' : undefined}>
                  {row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
